import jsonAPI from './json-api'

class Message {
  constructor () {
    this._conf = {
      baseURL: '/api/v1',
      method: 'post'
    }
  }

  // 消息列表
  messageList (param) {
    return jsonAPI.requestWithAuth('/getNoticeList', param, this._conf)
  }

  // 将未读消息变为已读消息
  noticeToRead (param) {
    return jsonAPI.requestWithAuth('/noticeToRead', param, this._conf)
  }
}

export default new Message()
